"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _buttonTypes = _interopRequireDefault(require("../../common/message-popup/button-types"));

var _messagePopup = _interopRequireDefault(require("../../common/message-popup/message-popup"));

const ConfirmDuplicateVideoPopup = props => {
  const {
    onClose,
    onConfirm,
    videoName
  } = props;
  return /*#__PURE__*/_react.default.createElement(_messagePopup.default, {
    className: "confirm-delete-video-popup",
    onClose: onClose,
    title: "Duplicate ".concat(videoName, "?"),
    hasClose: false,
    buttons: [{
      value: 'cancel',
      name: 'Cancel',
      onClick: onClose,
      type: _buttonTypes.default.WHITE
    }, {
      value: 'duplicate',
      name: 'Duplicate',
      onClick: onConfirm
    }]
  });
};

ConfirmDuplicateVideoPopup.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  onConfirm: _propTypes.default.func.isRequired,
  videoName: _propTypes.default.string.isRequired
};
var _default = ConfirmDuplicateVideoPopup;
exports.default = _default;